import React, {useEffect, useState} from "react";
import AppBar from "@material-ui/core/AppBar";
import {ErrorScreen, HeaderToolbar, Loading} from "../../components";
import {makeStyles, withStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import {useStore} from "../../store";
import {fetchAccount, invalidateAccount, setServices} from "../../store/actions";
import {useAuthUser} from "../../components/auth-provider";
import FuseAnimate from "../../components/fuse-animate/fuse-animate";
import Card from "@material-ui/core/Card";
import ausPhone from "../../utils/aus-phone";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import callCredits from "../../utils/call-credits";
import TextField from "@material-ui/core/TextField";
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import LabelOutlinedIcon from '@material-ui/icons/LabelOutlined';
import TimerOutlinedIcon from '@material-ui/icons/TimerOutlined';
import PhoneForwardedOutlinedIcon from '@material-ui/icons/PhoneForwardedOutlined';
import HourglassEmptyOutlinedIcon from '@material-ui/icons/HourglassEmptyOutlined';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import MuiAccordion from "@material-ui/core/Accordion";
import {Link} from "react-router-dom";
import {AccountService} from '../../services'
import {apiError} from "../../utils/toast";
import {useSnackbar} from "notistack";
import {FormControl, RadioGroup} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import resolveAction from "../../utils/resolve-action";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        marginTop: 16,
        justifyContent: "center",
    },
    card: {
        display: 'flex',
        flexDirection: 'column',
        padding: 24,
        width: '100%',
        maxWidth: 340,
        [theme.breakpoints.up('sm')]: {
            maxWidth: 360,
        },
    },
    green: {
        color: 'green',
    },
    red: {
        color: 'red',
    }
    }));

const Accordion = withStyles({
    root: {
        // border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
    root: {
        // backgroundColor: 'rgba(0, 0, 0, .03)',
        // borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
        padding: 0,
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        // backgroundColor: 'rgba(0, 0, 0, .03)',
        // padding: theme.spacing(2),
        padding: 0,
    },
}))(MuiAccordionDetails);

const ServicePage = ({match}) => {
    // console.log('Service props', props);
    const serviceId = match.params.id;
    const classes = useStyles();
    const {user} = useAuthUser();           // Get logged in user
    const [store, dispatch] = useStore();   // Get the global store
    const [state, setState] = useState({
        service: { action:{ id:'', type: ''}, meta:{}},
        nickname: '',
        isForwarding: true,
        isEditing: false,
        isFetching: false
    })

    // Scroll to top on mount
    useEffect( () => {
        document.getElementById('psb').scrollTo(0,0);
    }, [])  // <- empty deps means it runs only on load

    // Make sure the account is available in the store
    useEffect(()=> {
        dispatch(fetchAccount(user.accountId, store, dispatch))
    }, [user.accountId, store, dispatch])

    useEffect(() => {
        const services = store.account.services.filter(s => s.id.toString() === serviceId)
        if (services.length === 1) {
            setState(state => ({
                ...state,
                service: services[0],
                isForwarding: services[0].action.type !== 'reject',
            }));
        }
    },[store.account, serviceId])

    const {minutes, daysLeft} = callCredits(state.service)

    return (
        <div id="service-page" className={classes.root}>
            <AppBar position="fixed" className={classes.appBar}>
                <HeaderToolbar location="service"/>
            </AppBar>
            <Toolbar />

            <main className={classes.content}>
                { store.account.isFetching ? <Loading/> : null }
                { store.account.error && <ErrorScreen error={store.account.error}/> }
                { store.account.error === null && !store.account.isFetching ?
                    <FuseAnimate animation="transition.expandIn" delay={100}>
                        <div id="personal-details" className="flex flex-grow flex-col items-center">
                            <Card className={classes.card}>
                                <Typography variant="h4" color="secondary">{ausPhone(state.service.number)}</Typography>
                                <div className="text-lg pb-6">{state.service.meta.zone}</div>

                                <div className="text-lg flex flex-grow flex-row items-center pb-1">
                                    <TimerOutlinedIcon color="secondary" className="mr-2" />
                                    <div className="flex-grow">Call Minutes</div>
                                    <div><strong>{minutes}</strong> <span className="" >min left</span></div>
                                </div>
                                { minutes > 0 ?
                                    <div className="text-lg flex flex-grow flex-row items-center pb-1">
                                        <HourglassEmptyOutlinedIcon color="secondary" className="mr-2"/>
                                        <div className="flex-grow">Expiry</div>
                                        <div><strong>{daysLeft}</strong> <span className="">{daysLeft === 1 ? 'day':'days'} left</span></div>
                                    </div>
                                    : null
                                }
                                { minutes <= 0 ?
                                    <div className="flex flex-row my-2">
                                        <ReportProblemOutlinedIcon className="text-red-500 mr-2"/>
                                        <div className="text-gray-600">You have no call minutes remaining so you're not
                                            able to receive calls.</div>
                                    </div>
                                    : null
                                }
                                { daysLeft < 7 && minutes > 0 ?
                                    <div className="flex flex-row my-2">
                                        <ReportProblemOutlinedIcon className="text-red-500 mr-2"/>
                                        <div className="text-gray-600">
                                            { daysLeft === 0 ?
                                                <>Your call minutes expire today. Recharge immediately to roll over
                                                    your {minutes} remaining minutes.</>
                                                :
                                                <>You have only {daysLeft} { daysLeft === 1 ? 'day' : 'days'} before
                                                    your call minutes expire. Recharge now to roll over
                                                    your {minutes} remaining {minutes === 1 ? 'minute':'minutes'}.</>
                                            }
                                        </div>
                                    </div>
                                    : null
                                }
                                <div className="mb-6 mt-4 flex-grow">
                                    <Button
                                        component={Link} to={`/recharge/${serviceId}`}
                                        variant="outlined"
                                        color="secondary"
                                        className="w-full"
                                    >
                                        RECHARGE
                                    </Button>
                                </div>

                                {/*<ForwardingSwitch*/}
                                {/*    serviceId={serviceId}*/}
                                {/*    state={state}*/}
                                {/*    setState={setState}*/}
                                {/*    disabled={store.account.dialActions.length !== 1}*/}
                                {/*    store={store}*/}
                                {/*    dispatch={dispatch}*/}
                                {/*/>*/}

                                <ForwardingList
                                    serviceId={serviceId}
                                    state={state}
                                    setState={setState}
                                    store={store}
                                    dispatch={dispatch}
                                />

                                <NicknameField
                                    serviceId={serviceId}
                                    state={state}
                                    setState={setState}
                                    store={store}
                                    dispatch={dispatch}
                                />

                                <div className="mb-4 mt-4 flex-grow">
                                    <Button
                                        component={Link} to={`/transfer/${serviceId}`}
                                        variant="outlined"
                                        color="secondary"
                                        className="w-full"
                                    >
                                        TRANSFER NUMBER
                                    </Button>
                                </div>

                                <AboutAccordion daysLeft={daysLeft}/>

                            </Card>
                        </div>
                    </FuseAnimate>
                : null
                }
            </main>
        </div>

    );
}

/*
const ForwardingSwitch = ({serviceId, state, setState, disabled, store, dispatch}) => {
    const {enqueueSnackbar} = useSnackbar();

    const handleSwitchChange = (e) => {
        //console.log('handleSwitchChange', e.target.checked)

        let action = {id: null, type: 'reject'}
        if (e.target.checked) {
            action = {id: store.account.dialActions[0].id, type: 'dial'}
        }

        // Save the new name to the server
        AccountService.setServiceAction(store.account.id, serviceId, action)
            .then(() => {
                // Update our page state
                if (action.type === 'reject')
                setState({
                    ...state,
                    service: {...state.service, action},
                    isForwarding: action.type === 'reject',
                    isFetching:false,
                })
                // Fetch the account services and update our global store.
                fetchServices(store.account.id, dispatch)
            })
            .catch((error) => {
                // update our state
                setState({...state, isFetching:false})
                // display a snackbar message
                apiError("Your change could not be saved.", error, enqueueSnackbar)
            })

        setState({...state, isForwarding: e.target.checked})
    }


    return (
        <>
            <div className="text-lg flex flex-grow flex-row items-center">
                <PhoneForwardedOutlinedIcon color="secondary" className="mr-2"/>
                <div className="flex-grow"> Call Forwarding</div>
                <div>{state.isForwarding ? "ON" : "OFF"}</div>
                <div>
                    <Switch checked={state.isForwarding}
                            onChange={handleSwitchChange}
                            disabled={state.isFetching || disabled}
                    />
                </div>
            </div>
            <div className="mb-6 text-gray-500 pl-8">
                { state.isForwarding ?
                    <>Incoming calls go to your mobile</>
                    :
                    <>Incoming calls are rejected</>
                }
            </div>
        </>
    )

}
*/

const ForwardingList = ({serviceId, state, setState, store, dispatch}) => {
    const {enqueueSnackbar} = useSnackbar();

    console.log('state.isForwarding=', state.isForwarding)

    console.log('state.service=', state.service);
    // const dialActionId = state.service.action.id || "";
    // console.log('dialActionId=', dialActionId);

    const dialActions = store.account.dialActions || [];

    const handleSelection = (e) => {
        console.log('handleSelection', e.target.value)
        let action = {id: null, type: 'reject'}
        if (e.target.value !== '') {
            action = {id: e.target.value, type: 'dial'}
        }
        console.log('action:', action);

        // Save the new action to the server
        AccountService.setServiceAction(store.account.id, serviceId, action)
            .then(() => {
                // Update our page state
                if (action.type === 'reject')
                    setState({
                        ...state,
                        service: {...state.service, action},
                        isForwarding: action.type === 'reject',
                        isFetching:false,
                    })
                // Fetch the account services and update our global store.
                fetchServices(store.account.id, dispatch)
            })
            .catch((error) => {
                // update our state
                setState({...state, isFetching:false})
                // display a snackbar message
                apiError("Your change could not be saved.", error, enqueueSnackbar)
            })

        setState({...state, isForwarding: e.target.value !== ''})
    }

    return (
        <>
            <div className="text-lg flex flex-grow flex-row items-center">
                <PhoneForwardedOutlinedIcon color="secondary" className="mr-2"/>
                <div className="flex-grow"> Call Forwarding</div>
                {/*<div>{state.isForwarding ? "ON" : "OFF"}</div>*/}
                {/*<div>*/}
                {/*    <Switch checked={state.isForwarding}*/}
                {/*            onChange={handleSwitchChange}*/}
                {/*            disabled={state.isFetching || disabled}*/}
                {/*    />*/}
                {/*</div>*/}
            </div>
            <div className="my-2 text-gray-500 pl-8">Incoming calls will go to:</div>
            <div className="mb-6 pl-8">
                <FormControl>
                    <RadioGroup
                        name="forwardingRadioGroup"
                        value={state.service.action.id}
                        onChange={ e => handleSelection(e) }
                    >
                        { dialActions.map((dialAction, index) => (
                            <FormControlLabel
                                value={dialAction.id}
                                control={<Radio />}
                                label={resolveAction(store.account, state.service, dialAction).text}
                                key={dialAction.id}
                            />
                        ))}
                        <FormControlLabel value={null} control={<Radio />} label="Reject all calls"/>
                    </RadioGroup>
                </FormControl>
            </div>
        </>
    )

}

const NicknameField = ({serviceId, state, setState, store, dispatch}) => {
    const classes = useStyles();
    const {enqueueSnackbar} = useSnackbar();

    const handleNicknameEdit = (e) => {
        setState({...state, isEditing: true})
    }

    const handleCancelEdit = (e) => {
        setState({...state, isEditing: false})
    }

    const handleSaveEdit = (e) => {
        //console.log('handleSaveEdit', e)

        // Let the UI know we're busy
        setState({...state, isFetching: true})

        // Save the new name to the server
        AccountService.patchService(store.account.id, serviceId, {name: state.nickname})
            .then(() => {
                // Update our page state
                setState({...state, service: {...state.service, name:state.nickname}, isFetching:false, isEditing: false})
                // Invalidate the account so it's reloaded next time
                fetchServices(store.account.id, dispatch)
            })
            .catch((error) => {
                // update our state
                setState({...state, isFetching:false})
                // display a snackbar message
                apiError("Your change could not be saved.", error, enqueueSnackbar)
            })
    }

    const handleNicknameChange = (e) => {
        setState({...state, nickname: e.target.value})
    }

    return (
        <>
        <div className="text-lg flex flex-row items-center">
            <LabelOutlinedIcon color="secondary" className="mr-2"/>
            { state.isEditing ?
                <>
                    <div className="flex-grow">
                        <TextField autoFocus placeholder="Nickname"
                                   onChange={handleNicknameChange}
                                   value={state.nickname}
                        />
                    </div>
                    <IconButton
                        size="small"
                        onClick={handleSaveEdit}
                        disabled={state.isFetching || state.nickname === ''}
                        classes={{ root: classes.green }}
                    >
                        <CheckIcon  className="" />
                    </IconButton>
                    <IconButton
                        size="small"
                        onClick={handleCancelEdit}
                    >
                        <CloseIcon className="text-red-500"/>
                    </IconButton>
                </>
                :
                <>
                    <div className="flex-grow">{state.service.name}</div>
                    <IconButton
                        size="small"
                        onClick={handleNicknameEdit}
                        disabled={state.isFetching}
                        classes={{ root: classes.red }}
                    >
                        <EditOutlinedIcon color="secondary"/>
                    </IconButton>
                </>
            }
        </div>
        <div className="text-gray-600 pl-8 mb-2">A nickname for this number</div>
    </>
    )

}

const AboutAccordion = ({daysLeft}) => {

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                <div>About this service</div>
            </AccordionSummary>
            <AccordionDetails>
                <div className="flex flex-col font-light">
                    <ul className="list-disc mx-4 ml-4">
                        <li className="pb-3">
                            { daysLeft > 0 ?
                                <>Unused call minutes will expire in <strong>{daysLeft}&nbsp;{daysLeft === 1 ? 'day':'days'}
                                </strong> unless you recharge before.</>
                                :
                                <>Unused call minutes are lost if they expire. Recharge before
                                    expiry to roll-over your unused minutes.</>
                            }
                        </li>
                        <li className="pb-3">If you use all your call minutes you need to
                            recharge to keep receiving calls.
                        </li>
                        <li className="pb-3">Landline numbers and call minutes are not refundable.
                        </li>
                        <li className="pb-3">
                            The landline number will be removed from your account
                            if you have zero call minutes for 14 days or more.<br/>After that,
                            you may be able to recover the number but a new setup fee will apply.
                        </li>
                    </ul>
                </div>

            </AccordionDetails>
        </Accordion>
    )
}

const fetchServices = (accountId, dispatch) => {

    //console.log('fetchServices for ', accountId);
    AccountService.getServices(accountId)
        .then(services => {
            dispatch(setServices(services))
        })
        .catch(error => {
            //console.log('fetchServices error: error')
            dispatch(invalidateAccount())
        })
}

export default ServicePage;






